import * as React from "react";
const SvgDrink = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { id: "local_bar", d: "M2.92441 16V15.0303H7.28804V8.76461L0.351074 0.969697V0H15.1947V0.969697L8.25774 8.76461V15.0303H12.6214V16H2.92441ZM3.36077 2.90909H12.185L13.9305 0.969697H1.61532L3.36077 2.90909ZM7.77289 7.85455L11.3215 3.87879H4.22429L7.77289 7.85455Z", fill: "currentColor", style: {
  fill: "currentColor",
  fillOpacity: 1
} }));
export default SvgDrink;
